export const input = ({ theme: { dimensions } }) => ({
    maxWidth: dimensions.inputMaxWidth,
});
